module.exports = __webpack_public_path__ + "static/img/v60DetailImg.c1f6c3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v60DetailImg.png
// module id = hAus
// module chunks = 1